<template>
  <div>
    <div class="fc-banner" v-if="!temFormulaAtiva">
      <fa-icon icon="info-circle" class="fc-banner-icon" />
      <span>Sem fórmula ativa, o sistema usa o cálculo padrão.</span>
    </div>

    <div v-if="loading" class="fc-loading">
      <fa-icon icon="spinner" spin />
    </div>

    <div v-else>
      <div v-for="acao in acoes" :key="acao.chave" class="fc-group">
        <div class="fc-group-header" @click="toggleGroup(acao.chave)">
          <div class="fc-group-header-left">
            <fa-icon
              :icon="expandedGroups[acao.chave] === false ? 'chevron-right' : 'chevron-down'"
              class="fc-group-chevron"
            />
            <div class="fc-group-icon" :style="{ background: acao.cor + '15', color: acao.cor }">
              <fa-icon :icon="acao.icone" />
            </div>
            <div>
              <span class="fc-group-title">{{ acao.titulo }}</span>
              <span class="fc-group-desc">{{ acao.descricao }}</span>
            </div>
          </div>
          <div class="fc-group-header-right">
            <span class="fc-group-badge">{{ formulasPorAcao(acao.chave).length }}</span>
            <button class="fc-group-new" @click.stop="novaFormula(acao.chave)">
              <fa-icon icon="plus" /> Nova fórmula
            </button>
          </div>
        </div>

        <div class="fc-group-body" v-show="expandedGroups[acao.chave] !== false">
          <div
            v-for="formula in formulasPorAcao(acao.chave)"
            :key="formula.id"
            class="fc-formula"
            :class="{ 'fc-formula-ativa': formula.ativa }"
            @click="abrirFormula(acao.chave, formula.id)"
          >
            <div class="fc-formula-left">
              <div class="fc-formula-status" :class="formula.ativa ? 'on' : 'off'"></div>
              <div class="fc-formula-info">
                <span class="fc-formula-nome">{{ formula.titulo || 'Sem título' }}</span>
                <span class="fc-formula-meta" v-if="formula.descricao">{{ formula.descricao }}</span>
              </div>
            </div>
            <div class="fc-formula-right">
              <span v-if="formula.ativa" class="fc-tag tag-ativa">ATIVA</span>
              <span v-if="formula.acessacall" class="fc-tag tag-call">{{ nomeSistema('acessacall') }}</span>
              <span v-if="formula.acessafv" class="fc-tag tag-fv">{{ nomeSistema('acessafv') }}</span>
              <fa-icon icon="chevron-right" class="fc-formula-arrow" />
            </div>
          </div>

          <div class="fc-formulas-empty" v-if="formulasPorAcao(acao.chave).length === 0">
            <span>Nenhuma fórmula cadastrada — usando cálculo padrão</span>
            <button class="fc-formulas-empty-btn" @click="novaFormula(acao.chave)">
              Criar primeira fórmula
            </button>
          </div>
        </div>
      </div>
    </div>

    <ModalNovaFormula @ia="onIA" @manual="onManual" />
    <ModalGerarFormulaIA :acao="acaoSelecionada" @gerada="onFormulaGerada" />
  </div>
</template>

<script>
import { get } from "@/helpers/apiRequest";
import { getDescricaoAcessoSistema, loadAuthorizationAction } from "@/helpers/cargas";
import ModalNovaFormula from "./components/ModalNovaFormula.vue";
import ModalGerarFormulaIA from "./components/ModalGerarFormulaIA.vue";

export default {
  name: "FormulasCalculo",
  components: { ModalNovaFormula, ModalGerarFormulaIA },
  data() {
    return {
      loading: false,
      formulas: [],
      acaoSelecionada: "margem",
      expandedGroups: {},
      acoes: [
        {
          chave: "margem",
          titulo: "Margem",
          descricao: "Fórmula de cálculo de margem bruta e lucratividade dos produtos.",
          icone: "chart-line",
          cor: "#6366f1",
          permissao: "FORMULA_CALCULO_MARGEM",
        },
      ],
    };
  },
  computed: {
    temFormulaAtiva() {
      return this.formulas.some((f) => f.ativa);
    },
    temIA() {
      try {
        return loadAuthorizationAction('ADMIN_CONFIGURACAO_IA', 'GERAR_CONTEUDOS_POR_IA');
      } catch {
        return false;
      }
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.loading = true;
      try {
        const res = await get("/admin/formulas-calculo?per_page=100");
        this.formulas = res.itens || res.data || [];
      } catch (e) {
        console.error("Erro ao carregar fórmulas:", e);
      } finally {
        this.loading = false;
      }
    },
    toggleGroup(chave) {
      this.$set(this.expandedGroups, chave, this.expandedGroups[chave] === false ? true : false);
    },
    formulasPorAcao(acao) {
      return this.formulas.filter((f) => f.acao === acao);
    },
    novaFormula(acao) {
      if (!this.temIA) {
        this.$router.push(`/configuracoes/formulas-calculo/${acao}?new=1`);
        return;
      }
      this.acaoSelecionada = acao;
      this.$modal.show("modal-nova-formula");
    },
    onManual() {
      this.$modal.hide("modal-nova-formula");
      this.$router.push(`/configuracoes/formulas-calculo/${this.acaoSelecionada}?new=1`);
    },
    onIA() {
      this.$modal.hide("modal-nova-formula");
      this.$modal.show("modal-gerar-formula-ia");
    },
    onFormulaGerada() {
      this.$router.push(`/configuracoes/formulas-calculo/${this.acaoSelecionada}?new=1`);
    },
    abrirFormula(acao, id) {
      this.$router.push(`/configuracoes/formulas-calculo/${acao}?id=${id}`);
    },
    nomeSistema(campo) {
      return getDescricaoAcessoSistema(campo);
    },
  },
};
</script>

<style scoped>
/* BANNER */
.fc-banner {
  display: flex; align-items: center; gap: 10px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #eff6ff, #f0f4ff);
  border: 1px solid #dbeafe;
  border-radius: 8px;
  margin-bottom: 20px;
  color: #3b82f6;
  font-size: 0.85rem;
}
.fc-banner-icon { flex-shrink: 0; }
.fc-loading { text-align: center; padding: 60px; color: #9ca3af; font-size: 1.5rem; }

/* GRUPO */
.fc-group {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
}
.fc-group-header {
  display: flex; justify-content: space-between; align-items: center;
  padding: 14px 20px;
  cursor: pointer; transition: background 0.15s;
  user-select: none;
}
.fc-group-header:hover { background: #fafaff; }
.fc-group-header-left { display: flex; align-items: center; gap: 12px; }
.fc-group-header-right { display: flex; align-items: center; gap: 10px; }
.fc-group-chevron { color: #9ca3af; font-size: 0.7rem; width: 14px; transition: transform 0.2s; }
.fc-group-icon {
  width: 36px; height: 36px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.9rem; flex-shrink: 0;
}
.fc-group-title { font-size: 0.95rem; font-weight: 700; color: #1f2937; display: block; }
.fc-group-desc { font-size: 0.72rem; color: #9ca3af; display: block; }
.fc-group-badge {
  background: #f3f4f6; color: #6b7280; font-size: 0.7rem; font-weight: 700;
  padding: 2px 8px; border-radius: 10px; min-width: 22px; text-align: center;
}
.fc-group-new {
  display: flex; align-items: center; gap: 6px;
  padding: 7px 16px; border: none; border-radius: 8px;
  background: #6366f1; color: #fff; font-size: 0.78rem;
  font-weight: 600; cursor: pointer; transition: all 0.2s;
}
.fc-group-new:hover { background: #4f46e5; box-shadow: 0 4px 12px rgba(99,102,241,0.25); }
.fc-group-body { border-top: 1px solid #f3f4f6; }

/* LISTA DE FÓRMULAS */
.fc-formulas { }
.fc-formula {
  display: flex; justify-content: space-between; align-items: center;
  padding: 12px 20px;
  cursor: pointer; transition: background 0.15s;
  border-bottom: 1px solid #f9fafb;
}
.fc-formula:last-child { border-bottom: none; }
.fc-formula:hover { background: #fafaff; }
.fc-formula-ativa { border-left: 3px solid #059669; }
.fc-formula-left { display: flex; align-items: center; gap: 12px; }
.fc-formula-status {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
}
.fc-formula-status.on { background: #10b981; box-shadow: 0 0 4px rgba(16,185,129,0.4); }
.fc-formula-status.off { background: #d1d5db; }
.fc-formula-info { display: flex; flex-direction: column; }
.fc-formula-nome { font-size: 0.88rem; font-weight: 500; color: #374151; }
.fc-formula-meta { font-size: 0.72rem; color: #9ca3af; margin-top: 1px; }
.fc-formula-right { display: flex; align-items: center; gap: 6px; }
.fc-tag {
  font-size: 0.6rem; font-weight: 700; padding: 2px 8px;
  border-radius: 10px; text-transform: uppercase; letter-spacing: 0.3px;
}
.tag-ativa { background: #d1fae5; color: #059669; }
.tag-call { background: #dbeafe; color: #1d4ed8; }
.tag-fv { background: #fce7f3; color: #be185d; }
.fc-formula-arrow { color: #d1d5db; font-size: 0.7rem; transition: all 0.15s; }
.fc-formula:hover .fc-formula-arrow { color: #6366f1; transform: translateX(2px); }

/* VAZIO */
.fc-formulas-empty {
  padding: 24px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 0.82rem;
  display: flex; flex-direction: column; align-items: center; gap: 10px;
}
.fc-formulas-empty-btn {
  padding: 6px 14px; border: 1.5px solid #c7d2fe; border-radius: 8px;
  background: #fff; color: #6366f1; font-size: 0.78rem;
  font-weight: 500; cursor: pointer; transition: all 0.15s;
}
.fc-formulas-empty-btn:hover { background: #f5f3ff; border-color: #6366f1; }
</style>
